import React, { useState } from 'react';
import './HeroCardPreviewShell.css';
import './VirtualisSetaHeroCardPreview.css';
import virtualisSetaPreviewImg from '../img/virtualisseta.png';

const TABS = [
  {
    id: '360',
    label: '360° bejárás',
    shortLabel: '360°',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 4a8 8 0 1 0 8 8"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M20 4v4h-4M12 8v4l3 2"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 'szobak',
    label: 'Szobák',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M4 12h16v6H4v-6zM6 9h5v3H6V9zM13 9h5v3h-5V9z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path d="M4 18v2M20 18v2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'kozosseg',
    label: 'Közösségi terek',
    shortLabel: 'Közösség',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="9" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="15" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.6" />
        <path
          d="M5 18c0-2.2 1.8-4 4-4s4 1.8 4 4M11 18c0-2.2 1.8-4 4-4s4 1.8 4 4"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    id: 'udvar',
    label: 'Udvar',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 20V10M12 10c-2 0-3.5-1.5-3.5-3.5S10 3 12 3s3.5 1.5 3.5 3.5S14 10 12 10z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 20h8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>
    ),
  },
];

const VirtualisSetaHeroCardPreview = ({ onNavigate }) => {
  const [activeTab, setActiveTab] = useState('360');

  const handleCta = (e) => {
    e.stopPropagation();
    if (onNavigate) onNavigate();
  };

  const handleTabClick = (tabId, e) => {
    e.stopPropagation();
    setActiveTab(tabId);
  };

  return (
    <div
      className="hero-card-shell virtualis-seta-hero-preview"
      role="presentation"
      onClick={onNavigate}
    >
      <div className="hero-card-shell__header">
        <span className="hero-card-shell__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="8.5" cy="5.5" r="2" fill="currentColor" />
            <path
              d="M10.5 7.5l2.5 1.5 1.5 4.5"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5 6.5l1.8-.9 1.7.9M15.8 8.2l.9 3.3"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <div>
          <h3 className="hero-card-shell__title">Virtuális Séta</h3>
          <p className="hero-card-shell__subtitle">
            Tekintse meg otthonunkat kényelmesen, bárhonnan. Böngésszen szobák,
            közösségi terek és udvar között — mintha személyesen sétálna végig.
          </p>
        </div>
      </div>

      <div className="hero-card-shell__panel virtualis-seta-hero-preview__panel">
        <button
          type="button"
          className="virtualis-seta-hero-preview__preview"
          onClick={handleCta}
          aria-label="Virtuális séta megtekintése"
        >
          <img
            src={virtualisSetaPreviewImg}
            alt=""
            className="virtualis-seta-hero-preview__preview-img"
            loading="lazy"
            decoding="async"
          />
          <span className="virtualis-seta-hero-preview__play" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <polygon points="9,6 18,12 9,18" fill="currentColor" />
            </svg>
          </span>
        </button>
      </div>

      <div className="virtualis-seta-hero-preview__footer">
        <div
          className="virtualis-seta-hero-preview__tabs"
          role="tablist"
          aria-label="Virtuális séta kategóriák"
        >
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              aria-label={tab.label}
              title={tab.label}
              className={`virtualis-seta-hero-preview__tab${
                activeTab === tab.id ? ' is-active' : ''
              }`}
              onClick={(e) => handleTabClick(tab.id, e)}
            >
              <span className="virtualis-seta-hero-preview__tab-icon">{tab.icon}</span>
              <span className="virtualis-seta-hero-preview__tab-label">
                {tab.shortLabel || tab.label}
              </span>
            </button>
          ))}
        </div>

        <button type="button" className="hero-card-shell__cta" onClick={handleCta}>
          SÉTA INDÍTÁSA <span aria-hidden="true">→</span>
        </button>
      </div>
    </div>
  );
};

export default VirtualisSetaHeroCardPreview;
